import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { EmailExtensionValidator, TypeSafeFormBuilder, TypeSafeFormGroup } from '@yourcause/common';
import { AnalyticsService, EventType } from '@yourcause/common/analytics';
import { I18nService } from '@yourcause/common/i18n';
import { YCModalComponent } from '@yourcause/common/modals';
export interface UserAddEditGroup {
  firstName: string;
  lastName: string;
  email: string;
  jobTitle: string;
  isSSO: boolean;
}
export interface UserAddEdit extends UserAddEditGroup {
  ssoId: string;
  isBbidLinked: boolean;
  numberOfClients: number;
}

@Component({
  selector: 'gc-add-edit-user-modal',
  templateUrl: 'add-edit-user-modal.component.html',
  styleUrls: ['./add-edit-user-modal.component.scss']
})
export class AddEditUserModalComponent extends YCModalComponent<UserAddEditGroup> implements OnInit {
  @Input() existingUser: UserAddEdit;

  formGroup: TypeSafeFormGroup<UserAddEditGroup>;
  isSsoUser = false;
  noEditsAllowed = false;
  showSsoFlag = true;
  modalHeader: string;
  createUserHeader = this.i18n.translate(
    'USERS:hdrCreateUser',
    {},
    'Create User'
  );
  editUserHeader = this.i18n.translate(
    'USERS:hdrEditUser',
    {},
    'Edit User'
  );

  constructor (
    private formBuilder: TypeSafeFormBuilder,
    private analyticsService: AnalyticsService,
    private i18n: I18nService
  ) {
    super();
  }

  ngOnInit () {
    this.setHelpers();
    this.formGroup = this.formBuilder.group<UserAddEditGroup>({
      firstName: [
        this.existingUser?.firstName || '',
        [Validators.required, Validators.maxLength(50)]
      ],
      lastName: [
        this.existingUser?.lastName || '',
        [Validators.required, Validators.maxLength(50)]
      ],
      jobTitle: [
        this.existingUser?.jobTitle || '',
        [Validators.required, Validators.maxLength(50)]
      ],
      email: [
        this.existingUser?.email || '', [
          Validators.required,
          EmailExtensionValidator,
          Validators.maxLength(254)
        ]
      ],
      isSSO: this.existingUser?.isSSO || false
    });
    this.modalHeader = this.existingUser ? this.editUserHeader : this.createUserHeader;
  }

  setHelpers () {
    this.isSsoUser = !!this.existingUser?.isSSO || !!this.existingUser?.ssoId;
    if (!!this.existingUser) {
      if (!this.isSsoUser) {
        if (!this.existingUser.isBbidLinked) {
          this.noEditsAllowed = this.existingUser.numberOfClients > 1;
        } else {
          this.showSsoFlag = false;
          this.noEditsAllowed = true;
        }
      }
    }
  }

  onCancel () {
    this.closeModal.emit();
  }

  onSubmit () {
    this.closeModal.emit(this.formGroup.value);
    this.analyticsService.emitEvent({
      eventName: this.existingUser ? 'Edit user submit' : 'Add user submit',
      eventType: EventType.Click,
      extras: null
    });
  }
}
